import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { HybridClassEventType } from '../hybrid-classes-events';
import { GTMService } from '../../shared/gtm.service';
import { WindowService } from '../../shared/window.service';

@Component({
  selector: 'lp2-hybrid-classes-page',
  template: '<iframe *ngIf="src" id="hybrid-classes-iframe" [src]="src | safeUrl" frameborder="0" allow="microphone; autoplay; camera"></iframe>',
  styleUrls: ['./hybrid-classes-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HybridClassesPageComponent {

  private classroomId: string;
  private liveClassData: string;

  public get src(): string | null {
    if (!this.classroomId || !this.oeAppService.environment || !this.oeAppPersonService.contactId) {
      return null;
    }
    return `${this.oeAppService.webHybridClassesPageHost}?env=${this.oeAppService.environment}&classroomId=${this.classroomId}&contactId=${this.oeAppPersonService.contactId}&liveClassData=${this.liveClassData}`;
  }

  constructor(
    private readonly oeAppService: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly gtmService: GTMService,
    private readonly windowService: WindowService
  ) {
    const urlParams = new URLSearchParams(window.location.search);
    this.classroomId = urlParams.get('classroomId');
    this.liveClassData = urlParams.get('liveClassData');
  }

  ngOnInit() {
    window.addEventListener('message', this.handleEvents, false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }

  public handleEvents = ({ data, origin }) => {
    if (!isIFrameSameOrigin(this.oeAppService.webHybridClassesPageHost, origin)) {
      return;
    }

    switch (data.type) {
      case HybridClassEventType.HYBRID_CLASS_CLOSE_EVENT:
        this.windowService.redirectToHref('/');
        break;
      case HybridClassEventType.HYBRID_CLASS_TRACKING_EVENT:
        this.gtmService.sendGA4Event(data.data);
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./ts/app/hybrid-classes/hybrid-classes-page/hybrid-classes-page.component.ts